/**
 * ViewDetailModal — read-only detail view for a Test Scenario or Test Case.
 */
import React from 'react';
import './ViewDetailModal.css';

interface Field { label: string; value: React.ReactNode; }

interface ViewDetailModalProps {
  title: string;
  subtitle?: string;
  fields: Field[];
  tags?: string[];
  onClose: () => void;
}

const PRIORITY_COLOR: Record<string, string> = {
  Critical: '#dc3545', High: '#fd7e14', Medium: '#ffc107', Low: '#28a745',
};

export const ViewDetailModal: React.FC<ViewDetailModalProps> = ({ title, subtitle, fields, tags, onClose }) => (
  <div className="vdm-overlay" onClick={onClose}>
    <div className="vdm-modal" onClick={e => e.stopPropagation()}>
      <div className="vdm-header">
        <div>
          <h2 className="vdm-title">{title}</h2>
          {subtitle && <p className="vdm-subtitle">{subtitle}</p>}
        </div>
        <button className="vdm-close" onClick={onClose}>×</button>
      </div>

      <div className="vdm-body">
        {fields.map((f, i) => f.value ? (
          <div key={i} className="vdm-field">
            <div className="vdm-label">{f.label}</div>
            <div className="vdm-value">{f.value}</div>
          </div>
        ) : null)}

        {tags && tags.length > 0 && (
          <div className="vdm-field">
            <div className="vdm-label">Tags</div>
            <div className="vdm-tags">
              {tags.map(tag => (
                <span key={tag} className="vdm-tag">{tag}</span>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="vdm-footer">
        <button className="vdm-btn-close" onClick={onClose}>Close</button>
      </div>
    </div>
  </div>
);

export function priorityBadge(priority: string) {
  return (
    <span style={{
      background: PRIORITY_COLOR[priority] || '#6c757d',
      color: 'white', padding: '2px 10px', borderRadius: 12,
      fontSize: 12, fontWeight: 600
    }}>{priority}</span>
  );
}
